let _$q;
let _emDataService;

export default function enterpriseModelingUniqueProcessName(
  $q,
  emDataService
) {
  _$q = $q;
  _emDataService = emDataService;

  console.log('enterpriseModelingUniqueProcessName created');
  return {
    restrict: 'A',
    require: 'ngModel',
    link: (scope, element, attributes, ngModel) => {
      const departmentId = attributes.departmentId || 0;
      const processId = attributes.processId || 0;
      ngModel.$asyncValidators.emProcessUniqueName = (modelValue) => {
        const defer = _$q.defer();
        _emDataService.checkProcessExists(departmentId, processId, modelValue).then((data) => {
          if (data && data.data.result === false) {
            defer.resolve();
          } else {
            defer.reject();
          }
        }).catch(defer.reject);
        return defer.promise;
      };
    },
  };
}

enterpriseModelingUniqueProcessName.$inject = [
  '$q',
  'emDataService',
];
